<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import PAF01 from './PAF01.vue'


  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ PAF01 ],
    computed: {
      itemsSuperRainbowSkyIR () {
        const index = _.findIndex(this.items, { id: 'IR04-16' })
        return this.items.slice(index, index + 4)
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="プリリズADチャンネル|🥚 ER 🥚" color="#44cd1f" :items="collection('PRADCh', 'ER')" />
      <ItemList title="プリリズADチャンネル|PR ★★★" color="#ffa1bc" :items="collection('PRADCh', 'PR')" />
      <ItemList title="プリリズADチャンネル|SR ★★" color="#00c7da" :items="collection('PRADCh', 'SR')" />
    </template>

    <template #col2>
      <ItemList title="プリリズADチャンネル|R ★" color="#feab0d" :items="collection('PRADCh', 'R')" />
    </template>

    <template #col3>
      <ItemList title="プリズムボイスチャンネル|🥚 ER 🥚" color="#44cd1f" :items="collection('PrismVoiceCh', 'ER')" />
      <ItemList title="プリズムボイスチャンネル|PR ★★★" color="#ffa1bc" :items="collection('PrismVoiceCh', 'PR')" />
    </template>

    <template #col4>
      <ItemList title="プリズムボイスチャンネル|SR ★★" color="#00c7da" :items="collection('PrismVoiceCh', 'SR')" />
    </template>

    <template #col5>
      <ItemList title="プリティーコレクション1|ニコチケ PR ★★★" color="#ffa1bc" :items="collection('PrettyCollection1', 'PR')" />
    </template>

    <template #col6>
      <ItemList title="プリティーコレクション1|ニコチケ SR ★★" color="#00c7da" :items="collection('PrettyCollection1', 'SR')" />
    </template>

    <template #col7>
      <ItemList title="イルミナージュコーデ|✨ IR ✨" color="#edd50f" :items="itemsSuperRainbowSkyIR" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

    <template #col8>
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
